'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-273b5552.js');
var styled = require('styled-components');
var React = require('react');
var breakpoints = require('./breakpoints-5748ddd8.js');
var modules_combineMediaQueries = require('./modules/combine-media-queries/index.js');
var defaultTheme = require('./defaultTheme-068d5ee4.js');
var withStyles = require('./withStyles-b393a9eb.js');
var deprecatedPropType = require('./deprecatedPropType-e4925b44.js');
var useMediaQuery = require('./useMediaQuery-8229fb6d.js');
var Box = require('./Box-b10f6752.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function requirePropFactory(componentNameInError) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}

var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  var styles = {};
  GRID_SIZES.forEach(function (size) {
    var key = "grid-".concat(breakpoint, "-").concat(size);

    if (size === true) {
      // For the auto layouting
      styles[key] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
      return;
    }

    if (size === 'auto') {
      styles[key] = {
        flexBasis: 'auto',
        flexGrow: 0,
        maxWidth: 'none'
      };
      return;
    } // Keep 7 significant numbers.


    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41

    styles[key] = {
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    };
  }); // No need for a media query for the first size.

  if (breakpoint === 'xs') {
    defaultTheme._extends(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function getOffset(val) {
  var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var parse = parseFloat(val);
  return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
}

function generateGutter(theme, breakpoint) {
  var styles = {};
  SPACINGS.forEach(function (spacing) {
    var themeSpacing = theme.spacing(spacing);

    if (themeSpacing === 0) {
      return;
    }

    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: "-".concat(getOffset(themeSpacing, 2)),
      width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
      '& > $item': {
        padding: getOffset(themeSpacing, 2)
      }
    };
  });
  return styles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',


var styles = function styles(theme) {
  return defaultTheme._extends({
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },

    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: 'border-box',
      margin: '0' // For instance, it's useful when used with a `figure` element.

    },

    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },

    /* Styles applied to the root element if `direction="column"`. */
    'direction-xs-column': {
      flexDirection: 'column'
    },

    /* Styles applied to the root element if `direction="column-reverse"`. */
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },

    /* Styles applied to the root element if `direction="row-reverse"`. */
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `wrap="nowrap"`. */
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },

    /* Styles applied to the root element if `wrap="reverse"`. */
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },

    /* Styles applied to the root element if `alignItems="center"`. */
    'align-items-xs-center': {
      alignItems: 'center'
    },

    /* Styles applied to the root element if `alignItems="flex-start"`. */
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },

    /* Styles applied to the root element if `alignItems="flex-end"`. */
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },

    /* Styles applied to the root element if `alignItems="baseline"`. */
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },

    /* Styles applied to the root element if `alignContent="center"`. */
    'align-content-xs-center': {
      alignContent: 'center'
    },

    /* Styles applied to the root element if `alignContent="flex-start"`. */
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },

    /* Styles applied to the root element if `alignContent="flex-end"`. */
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },

    /* Styles applied to the root element if `alignContent="space-between"`. */
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },

    /* Styles applied to the root element if `alignContent="space-around"`. */
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },

    /* Styles applied to the root element if `justifyContent="center"`. */
    'justify-content-xs-center': {
      justifyContent: 'center'
    },

    /* Styles applied to the root element if `justifyContent="flex-end"`. */
    'justify-content-xs-flex-end': {
      justifyContent: 'flex-end'
    },

    /* Styles applied to the root element if `justifyContent="space-between"`. */
    'justify-content-xs-space-between': {
      justifyContent: 'space-between'
    },

    /* Styles applied to the root element if `justifyContent="space-around"`. */
    'justify-content-xs-space-around': {
      justifyContent: 'space-around'
    },

    /* Styles applied to the root element if `justifyContent="space-evenly"`. */
    'justify-content-xs-space-evenly': {
      justifyContent: 'space-evenly'
    }
  }, generateGutter(theme, 'xs'), theme.breakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};
var Grid = /*#__PURE__*/React__namespace.forwardRef(function Grid(props, ref) {
  var _props$alignContent = props.alignContent,
      alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent,
      _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems,
      classes = props.classes,
      classNameProp = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$container = props.container,
      container = _props$container === void 0 ? false : _props$container,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'row' : _props$direction,
      _props$item = props.item,
      item = _props$item === void 0 ? false : _props$item,
      justify = props.justify,
      _props$justifyContent = props.justifyContent,
      justifyContent = _props$justifyContent === void 0 ? 'flex-start' : _props$justifyContent,
      _props$lg = props.lg,
      lg = _props$lg === void 0 ? false : _props$lg,
      _props$md = props.md,
      md = _props$md === void 0 ? false : _props$md,
      _props$sm = props.sm,
      sm = _props$sm === void 0 ? false : _props$sm,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 0 : _props$spacing,
      _props$wrap = props.wrap,
      wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap,
      _props$xl = props.xl,
      xl = _props$xl === void 0 ? false : _props$xl,
      _props$xs = props.xs,
      xs = _props$xs === void 0 ? false : _props$xs,
      _props$zeroMinWidth = props.zeroMinWidth,
      zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth,
      other = defaultTheme._objectWithoutProperties(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "justifyContent", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);

  var className = withStyles.clsx(classes.root, classNameProp, container && [classes.container, spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], (justify || justifyContent) !== 'flex-start' && classes["justify-content-xs-".concat(String(justify || justifyContent))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
  return /*#__PURE__*/React__namespace.createElement(Component, defaultTheme._extends({
    className: className,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Grid.propTypes = {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */
  alignContent: defaultTheme.PropTypes.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),

  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */
  alignItems: defaultTheme.PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  /**
   * The content of the component.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: defaultTheme.PropTypes.bool,

  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */
  direction: defaultTheme.PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: defaultTheme.PropTypes.bool,

  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   * @deprecated Use `justifyContent` instead, the prop was renamed
   */
  justify: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']), 'Use `justifyContent` instead, the prop was renamed.'),

  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */
  justifyContent: defaultTheme.PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: defaultTheme.PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: defaultTheme.PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: defaultTheme.PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */
  spacing: defaultTheme.PropTypes.oneOf(SPACINGS),

  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */
  wrap: defaultTheme.PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: defaultTheme.PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: defaultTheme.PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: defaultTheme.PropTypes.bool
} : void 0;
var StyledGrid$1 = withStyles.withStyles(styles, {
  name: 'MuiGrid'
})(Grid);

if (process.env.NODE_ENV !== 'production') {
  var requireProp = requirePropFactory('Grid');
  StyledGrid$1.propTypes = defaultTheme._extends({}, StyledGrid$1.propTypes, {
    alignContent: requireProp('container'),
    alignItems: requireProp('container'),
    direction: requireProp('container'),
    justifyContent: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('item')
  });
}

var Grid$1 = StyledGrid$1;

/**
 * Produces a media query for this breakpoint by determining
 *   where the next defined breakpoint is.
 *
 * @param props - GridItemProperties
 * @param breakpoint - Current Breakpoint
 * @param currentIndex - Index of current breakpoint
 * @param all - Full list of breakpoints
 */
var createMediaQuery = function createMediaQuery(props, breakpoint, currentIndex, all) {
  // Find the smallest breakpoint that is bigger than this but
  //  has a size declaration.
  var nextIndex = all.findIndex(function (x, i) {
    return i > currentIndex && props[x];
  }) - 1;
  if (nextIndex >= currentIndex) {
    // If it's the next index...
    if (nextIndex === currentIndex) {
      // ... this css is only for this index.
      return props.theme.breakpoints.only(breakpoint);
    }
    // ... otherwise it's for everything between these breakpoints
    return props.theme.breakpoints.between(breakpoint, all[nextIndex]);
  }
  return props.theme.breakpoints.up(breakpoint);
};

/**
 * Determines what media queries to generate for hiding this grid item.
 *   Does this by checking for any breakpoints with a "0" size (e.g.
 *   `xs={0}`) and then determining what the next highest breakpoint is.
 * Then turns the media queries into a comma-delimited list so that all
 *   applicable queries follow the same logic.
 */
var createNoDisplaySelectors = function createNoDisplaySelectors(props) {
  return modules_combineMediaQueries.combineMediaQueries(breakpoints.BREAKPOINTS.reduce(function (acc, breakpoint, index, all) {
    if (props[breakpoint] === 0) {
      acc.push(createMediaQuery(props, breakpoint, index, all));
    }
    return acc;
  }, [])) || 'never';
};

/**
 * Produces media-query blocks that set `display: none` for any breakpoints
 *   with a "0" grid size (e.g. `xs={0}`), e.g.:
 * ```css
 * @media (min-width:0px) and (max-width:511.95px),
 * @media (min-width:768px) and (max-width:1279.95px) {
 *   display: none;
 * }
 * ```
 */
var noDisplayMixin = styled.css(["", "{display:none;}"], function (props) {
  return createNoDisplaySelectors(props);
});

var _templateObject$3;
var _excluded$1 = ["xs", "sm", "md", "lg", "xl"];
var coerceZeroIntoFalse = function coerceZeroIntoFalse(size) {
  return size === 0 ? false : size;
};
var GridItem = function GridItem(props) {
  var xs = props.xs,
    sm = props.sm,
    md = props.md,
    lg = props.lg,
    xl = props.xl,
    other = _rollupPluginBabelHelpers._objectWithoutProperties(props, _excluded$1);
  var validGridSizes = React.useMemo(function () {
    return {
      xs: coerceZeroIntoFalse(xs),
      sm: coerceZeroIntoFalse(sm),
      md: coerceZeroIntoFalse(md),
      lg: coerceZeroIntoFalse(lg),
      xl: coerceZeroIntoFalse(xl)
    };
  }, [xs, sm, md, lg, xl]);
  return /*#__PURE__*/React__default['default'].createElement(Grid$1, _rollupPluginBabelHelpers._extends({
    item: true
  }, _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, other), validGridSizes)));
};
var StyledGridItem = styled__default['default'](GridItem)(_templateObject$3 || (_templateObject$3 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n"])), noDisplayMixin);

/**
 * A wrapper around Material UI's {@link Grid} element with the
 *   `item` property forced on.
 * Uses an intermediary GridItem component to apply the desired styling
 *   to hide the element if the `xs` property, etc., is 0 without
 *   passing invalid props to the underlying Grid element.
 *
 *  - ZeroHeight: {@link https://zeroheight.com/7b3231350/p/54c9c6-grid}
 *  - Material UI: {@link https://v4.mui.com/api/grid/}
 *
 * @param props - {@link OwnUpGridItemProps}
 */
var OwnUpGridItem = function OwnUpGridItem(props) {
  return /*#__PURE__*/React__default['default'].createElement(StyledGridItem, props);
};

var _templateObject$2;
var StyledGridBreak = styled__default['default'](OwnUpGridItem)(_templateObject$2 || (_templateObject$2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  /* HACK-ish: This className used to ensure it can override\n   *   Mui's paddings applied by classes appended at render time. */\n  &.break {\n    margin: 0;\n    flex: 1;\n    flex-basis: 100%;\n    padding: 0;\n  }\n"])));

var _excluded = ["spacing"];
var _templateObject$1;
var StyledGrid = styled__default['default'](Grid$1)(_templateObject$1 || (_templateObject$1 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant;
  return variant === 'slim' ? styled.css(["margin-top:0;margin-bottom:0;> .MuiGrid-item{padding-top:0;padding-bottom:0;}"]) : undefined;
});

/**
 * A wrapper around Material UI's {@link Grid} element with the `container`
 *   property forced on. Defines and responsively changes the sizing
 *   of the gutters based on the current screen size.
 *
 *  - ZeroHeight: {@link https://zeroheight.com/7b3231350/p/54c9c6-grid}
 *  - Material UI: {@link https://v4.mui.com/api/grid/}
 *
 * @param props - {@link OwnUpGridContainerProps}
 */
var OwnUpGridContainer = function OwnUpGridContainer(_ref2) {
  var spacing = _ref2.spacing,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref2, _excluded);
  // Check if the current breakpoint of the screen is small or below.
  var screenSizeSmallOrBelow = useMediaQuery.useMediaQuery(function (theme) {
    return theme.breakpoints.down('sm');
  });

  // Determine what spacing parameter to use
  var trueSpacing = React.useMemo(function () {
    // If spacing is overridden in the props, just use that.
    if (spacing !== undefined) {
      return spacing;
    }
    // Otherwise, return spacing based on the screen size:
    if (screenSizeSmallOrBelow) {
      // Use a space factor of 2 (8px * 2 = 16px) on smaller screens
      return 2;
    }
    // Use a space factor of 3 (8px * 3 = 24px) on larger screens
    return 3;
  }, [screenSizeSmallOrBelow, spacing]);

  // Return a Grid container with the spacing options and any other
  //   props passed forward.
  return /*#__PURE__*/React__default['default'].createElement(StyledGrid, _rollupPluginBabelHelpers._extends({
    container: true,
    spacing: trueSpacing
  }, props));
};

var _templateObject;
/**
 * {@link Box} component with dynamic size and margins based
 *   on the current screen size.
 */
var StyledGridWrapper = styled__default['default'](Box.Box)(_templateObject || (_templateObject = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  /* Maximum width is equal to the xl breakpoint size */\n  max-width: ", ";\n\n  /* Dynamically set the margin based on the current screen size\n   * default margin: 10x spacing factor (8px * 10 = 80px) */\n  margin: ", ";\n  /* medium breakpoint and down: 6 spacing factor (8px * 6 = 48px) */\n  ", " {\n    margin: ", ";\n  }\n  /* xsmall breakpoint and down: 3x spacing factor (8px * 3 = 24px) */\n  ", " {\n    margin: ", ";\n  }\n  /* At xl and above, the margins should be \"auto\" with a minimum of 80px.\n   *   Because there is no \"min margin\" css attribute, we can hack this by\n   *   setting the maximum width of this container to be the width of the\n   *   xl breakpoint, then when the screen size reaches the xl breakpoint\n   *   plus 160px (80px on both sides) switching the margins to 80px and\n   *   setting this container to take up 100% of its parent container.\n   * This screen size check is done with a custom media query.\n   */\n  ", " {\n    margin: auto;\n    width: 100%;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.breakpoints.values.xl, "px");
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(0, 10);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down('md');
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing(0, 6);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.down('xs');
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing(0, 3);
}, function (_ref7) {
  var theme = _ref7.theme;
  return (// media query block starts at the xl breakpoint plus 10x spacing factor (8px * 10 = 80px)
    "@media (min-width: ".concat(theme.breakpoints.values.xl + theme.spacing(10) * 2, "px)")
  );
});

/**
 * A wrapper around Material UI's {@link Box} component that
 *   enforces margins and size limitations for the grid it
 *   should contain.
 *
 * Should be used to wrap all {@link OwnUpGrid} layouts.
 *
 *  - ZeroHeight: {@link https://zeroheight.com/7b3231350/p/54c9c6-grid}
 *  - Material UI: {@link https://v4.mui.com/api/grid/}
 *
 * @param props - {@link OwnUpGridWrapperProps}
 */
var OwnUpGridWrapper = function OwnUpGridWrapper(props) {
  return /*#__PURE__*/React__default['default'].createElement(StyledGridWrapper, props);
};

exports.OwnUpGridContainer = OwnUpGridContainer;
exports.OwnUpGridItem = OwnUpGridItem;
exports.OwnUpGridWrapper = OwnUpGridWrapper;
exports.StyledGridBreak = StyledGridBreak;
//# sourceMappingURL=element-eba06ad0.js.map
